export enum Syntax {
	github = "GitHub Flavored Markdown",
	legacy = "Legacy",
	xml = "Xml",
}
